/**
 * WARNING: This component is auto-generated by the build script in the parent directory.
 * Do not edit this file, as any changes will be overwritten. Instead, edit the template and
 * svg files to make changes
 */
import React from "react";
import classNames from "classnames";
import { IIconProps, IconSize } from "../types";

const Hubspot = (props: IIconProps): React.ReactElement => {
  const { className, size = IconSize.Medium, ...rest } = props;
  const iconClass = classNames("kl-icon", `kl-icon--${size}`, className);
  return React.createElement(
    "svg",
    { width: "24", height: "24", viewBox: "0 0 24 24", className: iconClass, ...rest },
    <path
      fill="#FF7A59"
      d="M17.564 8.685V6.143a1.958 1.958 0 001.129-1.764v-.058c0-1.08-.876-1.957-1.957-1.957h-.059c-1.08 0-1.957.876-1.957 1.957v.058a1.958 1.958 0 001.129 1.764v2.542a5.543 5.543 0 00-2.636 1.16l-6.97-5.429c.05-.18.076-.364.079-.55a2.205 2.205 0 10-2.208 2.202A2.181 2.181 0 005.2 5.772l6.864 5.341a5.56 5.56 0 00.085 6.262l-2.088 2.088a1.795 1.795 0 00-.522-.085 1.81 1.81 0 101.813 1.813 1.79 1.79 0 00-.085-.522l2.065-2.066a5.57 5.57 0 104.232-9.918zm-.855 8.359a2.857 2.857 0 110-5.713 2.857 2.857 0 01.002 5.711"
    />,
  );
};

export default Hubspot;
